<template>
  <div class="MainVisual__back_underlayer">
    <div class="MainVisual">
      <div class="MainVisual__area MainVisual__area_tv">
        <div class="MainVisual__tx_area">
          <p class="MainVisual__tx_main MainVisual__tx_main--lg ft_en">
            初めての方へ
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MelonTVBanner'
}
</script>
